import { render, staticRenderFns } from "./toolbox-canvas.vue?vue&type=template&id=e2c061d2&scoped=true"
import script from "./toolbox-canvas.ts?vue&type=script&lang=ts&external"
export * from "./toolbox-canvas.ts?vue&type=script&lang=ts&external"
import style0 from "./toolbox-canvas.less?vue&type=style&index=0&id=e2c061d2&prod&lang=less&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2c061d2",
  null
  
)

export default component.exports